export default __webpack_public_path__ + "static/media/deposit-qrcode-step4.8805d25e.png";